const MODE_KEY = "conecta_google_mode";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogle(mode = "login", returnPath = "/") {
  sessionStorage.setItem(MODE_KEY, mode);
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export const takeGoogleMode = () => {
  const m = sessionStorage.getItem(MODE_KEY) || "login";
  sessionStorage.removeItem(MODE_KEY);
  return m;
};

export const hasGoogleSession = () => window.location.hash.includes("session_id=");
